(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/hooks/assets/javascripts/use-track-my-bets-state.js') >= 0) return;  svs.modules.push('/components/pool-betting/hooks/assets/javascripts/use-track-my-bets-state.js');
"use strict";


const {
  useEffect
} = React;
const {
  trackEvent
} = svs.components.analytics;
const {
  drawStateEnums
} = svs.components.sport.tipsenShared;
const useTrackMyBetsState = _ref => {
  let {
    drawState,
    productName
  } = _ref;
  useEffect(() => {
    if (!drawState || !productName) {
      return;
    }
    const getDrawState = () => {
      if (drawState === drawStateEnums.FINALIZED) {
        return 'postgame';
      }
      if (drawState === drawStateEnums.LIVE) {
        return 'live';
      }
      return 'pregame';
    };
    const analyticsEvent = {
      category: 'mina-spel',
      action: getDrawState(),
      opt_label: productName
    };
    trackEvent(analyticsEvent);
  }, [drawState, productName]);
};
setGlobal('svs.components.poolBetting.hooks.useTrackMyBetsState', useTrackMyBetsState);

 })(window);